import loadingAnim from "./assets/loaderAnimation.json";
import { Lottie } from "../Lottie";

const GenericLoader = () => <Lottie animationData={loadingAnim} />;

export default GenericLoader;
